
const origin = process.env.REACT_APP_API_ENDPOIN;
export default class ProductService {

    static getProduct = async (sku, signal) => {
        const res = await fetch(`${origin}/api/get-product-details`, {
            method : 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body : JSON.stringify({
                sku : Number(sku)
            }),
            signal
        });
        return await res.json();
    }

}